
import {defineComponent, PropType} from "vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import {TradeContractFormat} from "@/store/modules/hcs/tradeContractFormat/model";

const defaultTradeContractFormat = {
  name: '',
  description: '',
};

export default defineComponent({
  name: "CreateTradeContractFormatForm",
  components: {TextFieldLike},
  inject: {
    form: {default: null}
  },
  props: {
    value: {
      type: [Object, Boolean] as PropType<Partial<TradeContractFormat> | false>,
    },
    serviceType: {
      type: String,
      required: true,
    },
    initialContractType: {
      type: String,
      default: 'draft',
    },
  },
  emits: [
    'input'
  ],
  data() {
    return {
      tradeContractFormat: {
        ...defaultTradeContractFormat
      },
    }
  },
  created() {
    this.form && this.form.register(this);
  },
  beforeDestroy() {
    this.form && this.form.unregister(this)
  },
  computed: {
    hasError(): boolean {
      const format = this.tradeContractFormat;
      return !format.name;

    },
  },
  methods: {
    handleChange() {
      this.$emit('input', {
        ...this.tradeContractFormat,
        serviceType: this.serviceType,
        sendType: 'push',
        contractType: this.initialContractType,
      });
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if(value !== false) {
          this.tradeContractFormat = value;
        }
      }
    }
  }
});
